import { StatusBadge } from "@/components/StatusBadge";
import { Panel } from "@/components/epidemic/Charts";

export const Thresholds = ({ items }) => (
  <Panel title="Surveillance des seuils épidémiques (7 derniers jours)" testId="epi-thresholds">
    <p className="text-xs text-stone-500 -mt-2 mb-3">Seuils définis dans le référentiel des pathologies de Sehatic-Pedia.</p>
    <div className="overflow-x-auto">
      <table className="w-full text-sm">
        <thead><tr className="text-left text-xs uppercase tracking-[0.1em] text-stone-500"><th className="py-2">Pathologie</th><th>Cas 7 j</th><th>Seuil</th><th className="w-48">Niveau</th><th>Statut</th></tr></thead>
        <tbody className="divide-y divide-stone-100">
          {items.filter((t) => t.cases_7d > 0 || t.level !== "normal").map((t) => (
            <tr key={t.pathology} data-testid={`threshold-row-${t.code}`}>
              <td className="py-2 font-medium text-stone-900">{t.pathology}</td>
              <td>{t.cases_7d}</td>
              <td>{t.threshold}</td>
              <td><div className="h-1.5 bg-stone-100 rounded w-40"><div className={`h-1.5 rounded ${t.level === "depasse" ? "bg-red-700" : t.level === "proche" ? "bg-amber-500" : "bg-green-600"}`} style={{ width: `${Math.min(100, t.ratio * 100)}%` }} /></div></td>
              <td><StatusBadge value={t.level} /></td>
            </tr>
          ))}
        </tbody>
      </table>
      {items.every((t) => t.cases_7d === 0) && <p className="text-sm text-stone-500 py-2">Aucun cas cette semaine pour les pathologies surveillées.</p>}
    </div>
  </Panel>
);
